import React, { useEffect, useState } from "react";
import {
  DetailFields,
  DownArrowDraw,
  DropDownSearchDraw,
  HaberForm,
  RightDrawerContainer,
} from "../../styledElements";
import { Button, Col, Form, Input, Row, Select } from "antd";
import { addNewGrade, getAllGrades } from "../../../Services/settingsServices";
import RightDrawerSidebar from "../../../Components/RightDrawer/rightDrawer";
import Iconmoon from "../../../Components/IconsFiles/icon";
import { capital_letter } from "../../../Utils/helper/helper";
const { Option } = Select;

export default function AddQualityDrawer({
  qualityDrawer,
  closeQualityDrawer,
  selectedRecord,
  onSaveQuality
}) {
  const [form] = Form.useForm();

  const [grades, setGrades] = useState([]);
  const [isGradeDropdownOpen, setGradeDropdown] = useState(false);
  const [selectGradeType, setSelectGradeType] = useState();
  const addQualityHandler = () => {
    form.submit();
  };

  const OnGradetoggleSelect = () => {
    setGradeDropdown((prevState) => !prevState);
  };
  const onChangeHandlerGradeBox = (value) => {
    setSelectGradeType(value);
  };
  const onFinish =async (values) => {
    console.log("Success:", values);
    // let qualityName = capital_letter(selectedRecord?.quality_name.trim());
    let qualityName = capital_letter(selectedRecord?.quality.trim());
    const requestBody = {
      grade: selectedRecord?.grade,
      quality: {
        // name: e.quality_name,
        name: qualityName.trim(),
        description: values.description ? values.description : "",
        value: true,
      },
    };
    try {
      const response = await addNewGrade(requestBody);
      console.log(response.data);
      if (response.error) {
        return Promise.reject(response.message);
      } else {
        onSaveQuality(qualityName.trim())
        closeQualityDrawer();
      }
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    getAllGrades("enabled")
      .then((response) => {
        setGrades(response.map((grade) => grade.name));
        // console.log("Grades", grades);
      })
      .catch((error) => {
        console.log(error);
      });
  }, []);
  return (
    <RightDrawerSidebar
      title="Add New Quality"
      subtitle=""
      visible={qualityDrawer}
      onClose={closeQualityDrawer}
    >
      <RightDrawerContainer>
        <div className="resetPassForm removePadLeft">
          <DetailFields className="marginBtnP">
            <HaberForm>
              <Form
                name="basic"
                autoComplete="off"
                className="haberLogin haberSignup"
                style={{ marginTop: "0" }}
                onFinish={onFinish}
                // onFinishFailed={onFinishFailed}
                form={form}
              >
                <Row className="centerAlign drawerField">
                  <Col span={24} >
                    <div className="">
                      <label>Grade</label>
                      <p>Quality is associated with this grade</p>
                    </div>
                  </Col>
                  <Col span={24} className="blockBreak">
                    <div className="boxFormType">
                      <Form.Item
                        name="grade"
                        rules={[
                          {
                            required: true,
                            message: "Please select a grade",
                          },
                        ]}
                        initialValue={selectedRecord?.grade}
                      >
                        <Input
                          placeholder="Grade"
                          disabled/>
                      </Form.Item>
                    </div>
                  </Col>
                </Row>

                <Row className="centerAlign drawerField">
                  <Col span={24}>
                    <div className="">
                      <label>Quality</label>
                      <p>Name of quality to be added</p>
                    </div>
                  </Col>
                  <Col span={24} className="blockBreak">
                    <div className="boxFormType">
                      <Form.Item
                        name="quality_name"
                        rules={[
                          {
                            required: true,
                            message: "quality is required",
                          },
                        ]}
                        initialValue={selectedRecord?.quality}
                      >
                        <Input placeholder="Quality" disabled />
                      </Form.Item>
                    </div>
                  </Col>
                </Row>

                <Row className="centerAlign drawerField">
                  <Col span={24}>
                    <div className="">
                      <label>
                        Description{" "}
                        <span style={{ fontStyle: "italic" }}>(Optional)</span>
                      </label>
                      <p>Description of the quality</p>
                    </div>
                  </Col>
                  <Col span={24} className="blockBreak">
                    <div className="boxFormType">
                      <Form.Item
                        name="description"
                        
                        initialValue={""}
                      >
                        <Input placeholder="description"  />
                      </Form.Item>
                    </div>
                  </Col>
                </Row>
                <div className="buttonFlex fixedBtm">
                  <Form.Item>
                    <Button
                      className="themeBtn"
                      // htmlType="submit"
                      onClick={() => addQualityHandler()}
                    >
                      <Iconmoon icon="addcircle" size={16} color="#ffffff" />{" "}
                      Add Quality
                    </Button>
                  </Form.Item>
                  <Form.Item>
                    <Button
                      //   htmlType="submit"
                      className="themeBtn noBg"
                      onClick={() => closeQualityDrawer()}
                    >
                      <Iconmoon icon="cancel" size={16} color="#EA655B" />{" "}
                      Cancel
                    </Button>
                  </Form.Item>
                </div>
              </Form>
            </HaberForm>
          </DetailFields>
        </div>
      </RightDrawerContainer>
    </RightDrawerSidebar>
  );
}
